<span
	[ngClass]="iconClasses"
	aria-hidden="true">
</span>
